import cloneDeep from 'lodash-es/cloneDeep'
import * as getters from './getters'
import mutations from './mutations'
import * as actions from './actions'

export const DEFAULT_FILTER_PARAMS = {
  active: true,
  report: null,
  temp: null,
  anonymous: null,
  department: null,
  position: null,
  query: '',
  sort_by: 'last_name',
  order_by: 'asc',
  with_subdepartments: true,
  page: 1,
  per_page: 25,
}

const state = {
  userData: [],
  userDepartments: [],
  filterParams: cloneDeep(DEFAULT_FILTER_PARAMS),
  pagination: {
    count: null,
    current: null,
    previous: null,
    next: null,
    pages: null,
    per_page: null,
  },
  isFetchingUsers: false,
}

export default {
  state,
  getters,
  mutations,
  actions,
}
